var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Header'),_c('Aside'),_c('Content'),(_vm.loadingFetch)?_c('v-overlay',{attrs:{"value":_vm.overlay,"z-index":"9999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50"}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }